/**
 * Modal overlay element that can open and close.
 * @extends	HTMLElement
 */
class ModalTrigger extends HTMLElement {
    /**
     * The name of the tag to create.
     * @returns {string}
     */
    static get tagName() {
        return 'modal-trigger'
    }

    /**
     * Gets and sets the modalId attribute value.
     * @property
     */
    get modalId() {
        return this.getAttribute('modal-id')
    }

    set modalId(value) {
        if (value === true) {
            this.setAttribute('modal-id', '')
        } else {
            this.removeAttribute('modal-id')
        }
    }

    get modalTitle() {
        return this.getAttribute('modal-title')
    }

    /**
     * Gets the modal element.
     */
    get modal() {
        return document.getElementById(this.modalId)
    }

    /**
     * Add click listener to open the modal
     */
    connectedCallback() {
        this.addEventListener('click', event => {
            const modal = this.modal;
            if (modal !== null) {
                if (this.modalTitle) {
                    modal.title = this.modalTitle;
                }
                modal.open = true;
            }
            event.preventDefault();
        });
        this.addEventListener('keydown', event => {
            if (event.key === 'Enter') {
                this.click();
            }
        });
    }
}

customElements.define(ModalTrigger.tagName, ModalTrigger)



// WEBPACK FOOTER //
// ./scripts/web-components/modal-trigger/index.js